module.exports = __webpack_public_path__ + "img/duanwu_ps_20.463cc340.jpg";